export default __webpack_public_path__ + "static/media/Deed of Contract_14.e118acd2.jpg";